<template>
  <div class="widget_box">
    <div v-if="showSeoUrl" class="show-widget-border">
      <div class="show-widget-title">Integrate to your website</div>
      <div class="show-widget-first">
        <div class="show-widget-first-img">
          <img style="width:100%;height:100%" src="@/assets/img/widget/show-widget-first.png" />
        </div>
        <div class="show-widget-first-right">
          <div class="show-widget-first-right-title">Embed a ShopVidi Widget</div>
          <div class="show-widget-first-right-content">ViLocal widget is a piece of code embedded in the website, ViLocal product service, we can help brands enter the store for trial sales, and enjoy the exclusive service provided by ShopVidi, online users provide offline purchase scenes, to achieve the effect of offline Showroom</div>
          <div class="show-widget-first-right-work">How it works<a class="show-widget-first-right-work-link" target="_blank" href="https://help.shopvidi.com/en/articles/8539436-vilocal-module-embedding-site-operation-guide">Widget Usage Guide</a></div>
          <div class="show-widget-first-right-bottom">Just embed our widget or button on your website and your customers can browse</div>
        </div>
      </div>
      <div class="show-widget-second">
        <div class="show-widget-second-title">Embed a ViLocal Widget</div>
        <div class="show-widget-second-step1">
          <div class="show-widget-second-step1-title">1</div>
          <div class="show-widget-second-step1-subtitle">Copy the ViLocal code</div>
        </div>
        <div class="show-widget-second-step1-content">
          <el-divider direction="vertical"></el-divider>
          <div class="show-widget-second-step1-text">{{content}}</div>
          <div class="show-widget-copy-border" @click="copy($event)"><i class="el-icon-copy-document" style="color:#262B2F;margin-right: 15px;"></i>Copy code</div>
        </div>
        <div class="show-widget-second-step2">
          <div class="show-widget-second-step2-title">2</div>
          <div class="show-widget-second-step2-subtitle">Embed ViLocal module into Shopify、official website and other official websites</div>
        </div>
        <div class="show-widget-second-step2-content">In the HTML/code editor, paste your iframe code.  </div>
        <div class="show-widget-second-step2-img"><img src="@/assets/img/widget/widget-middle.png"/></div>
      </div>
      <div class="show-widget-title" style="margin-top:30px">Wdiget Usage Guide</div>
      <iframe style="height:514px;width:100%;margin:0px auto;margin-top:20px;border:none;" :src="brandSeoUrl"></iframe>
      <div v-if="false" class="show-widget-title">Examples after embedding</div>
      <div v-if="false" class="show-widget-bottom-img"><img src="@/assets/img/widget/widget-bottom.png"/></div>
    </div>
    <div v-else class="hidden-widget-border">
      <img src="@/assets/img/widget/hidden-widget.png"/>
      <div class="hidden-widget-border-text">Your brand’s widget has not been generated yet. You will be nottified via email once it is generated. Please keep an eye on yourinbox</div>
    </div>
  </div>
</template>

<script>
import CustomBreadcrumb from '../components/custom-breadcrumb'
import { getAction } from '@/api/manage.js'
import { handleClipboard } from '@/utils/copy'
export default {
  components: {
    CustomBreadcrumb
  },
  created() {
    this.getWidget()
  },
  data() {
    return {
      showSeoUrl: false,
      content: '',
      brandSeoUrl: ''
    }
  },
  methods: {
    copy(e) {
      handleClipboard(this.content, e)
    },
    getWidget() {
      getAction('/vilocal/shop/order/api/v0.2/brand/seo-url').then(response => {
        if (response.success) {
          if (response.result) {
            this.showSeoUrl = response.result.showSeoUrl
            this.content = '<iframe style="height:514px;width:100%;margin:0 auto;border:none;" src="' + response.result.brandSeoUrl + '"></iframe>'
            this.brandSeoUrl = response.result.brandSeoUrl
            // this.showSeoUrl = true
            // response.result.brandSeoUrl = 'https://www.shopvidi.com/vilocal/xikezan'
            // this.content = '<iframe style="height:514px;width:100%;margin:0 auto;border:none;" src="' + response.result.brandSeoUrl + '"></iframe>'
          }
        } else {
          this.$message.warning(response.message)
        }
      })
    }
  }
}
</script>

<style lang="less" scoped>
.widget_title{
  margin: 0px 30px 0px 0px !important;
  height: 35px;
  line-height: 35px;
  margin-right: 0px !important;
}
.show-widget-border{
  .show-widget-title{
    font-size: 16px;
    font-family: Satoshi-Bold !important;
    color: #262B2F;
    opacity: 1;
  }
  .show-widget-first{
    margin-top: 26px;
    display: flex;
    height: 150px;
    border: 1px solid #E1E1E1 ;
    border-left: none;
    border-radius: 5px;
    .show-widget-first-img{
      width: 149px;
      height: 149px;
    }
    .show-widget-first-right{
      width: calc(100% - 150px);
      padding: 10px 0px 0px 20px;
      .show-widget-first-right-title{
        font-size: 14px;
        font-family: Satoshi-Medium !important;
        color: #262B2F;
        opacity: 1;
      }
      .show-widget-first-right-content{
        margin-top: 10px;
        font-size: 14px;
        font-family: Satoshi-Regular !important;
        line-height: 22px;
        color: #262B2F;
        opacity: 1;
      }
      .show-widget-first-right-work{
        margin-top: 10px;
        font-size: 14px;
        font-family: Satoshi-Medium !important;
        color: #262B2F;
        opacity: 1;
        .show-widget-first-right-work-link{
          margin-left: 10px;
          color: #262B2F;
        }
      }
      .show-widget-first-right-bottom{
        margin-top: 10px;
        font-size: 14px;
        font-family: Satoshi-Regular !important;
        color: #262B2F;
        opacity: 1;
      }
    }
  }
  .show-widget-second{
    margin-top: 27px;
    border: 1px solid #E1E1E1;
    opacity: 1;
    border-radius: 5px;
    padding: 20px 0px 0px 10px;
    .show-widget-second-title{
      font-size: 14px;
      font-family: Satoshi-Bold !important;
      color: #262B2F;
      opacity: 1;
    }
    .show-widget-second-step1,.show-widget-second-step2{
      display: flex;
      align-items: center;
      margin:30px 0px 0px 20px;
      .show-widget-second-step1-title,.show-widget-second-step2-title{
        display: flex;
        align-items: center;
        justify-content: center;
        background:#F4F4F4;
        width: 20px;
        height: 20px;
        border: 1px solid #E1E1E1;
        border-radius: 50%;
        opacity: 1;
      }
      .show-widget-second-step1-subtitle,.show-widget-second-step2-subtitle{
        margin-left: 10px;
        font-size: 14px;
        font-family: Satoshi-Medium !important;
        color: #262B2F;
        opacity: 1;
      }
    }
    .show-widget-second-step2{
      margin-top: 0px;
    }
    .show-widget-second-step2-content{
      margin:20px 0px 0px 50px;
      font-size: 14px;
      font-family: Satoshi-Regular;
      line-height: 36px;
      color: #262B2F;
      opacity: 1;
    }
    .show-widget-second-step2-img{
      margin:10px 0px 30px 50px;
      opacity: 1;
    }
    .show-widget-second-step1-content{
      height:108px;
      margin-left:22px;
      display: flex;
      align-items: center;
      /deep/ .el-divider--vertical{
        height: 100%;
      }
      .show-widget-second-step1-text{
        display: flex;
        align-items: center;
        justify-content: center;
        color: #FFFFFF;
        height: 50px;
        background: #262B2F;
        border: 1px solid #E1E1E1;
        opacity: 1;
        border-radius: 5px;
        margin-left: 10px;
        padding: 0px 20px;
      }
    }
  }
  .show-widget-bottom-img{
    margin-top: 20px;
  }
  .show-widget-copy-border{
    cursor: pointer;
    display: flex;
    align-items: center;
    justify-content: center;
    border: 1px solid #262B2F;
    opacity: 1;
    border-radius: 5px;
    width: 140px;
    height: 40px;
    margin-left: 20px;
    font-family: Satoshi-Regular;
  }
}
.hidden-widget-border{
  margin-top: 10%;
  display: flex;
  flex-direction: column;
  align-items: center;
  .hidden-widget-border-text{
    margin-top: 26px;
    font-size: 14px;
    font-family: Satoshi-Regular;
    color: #5D5D5D;
    opacity: 1;
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/vilocal/widget.vue